"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// https://stackoverflow.com/a/4760279/3533845

var dynamicSort = function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
    };
};

exports.default = dynamicSort;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/dynamicSort.js
// module id = 1308
// module chunks = 0